// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__hBeDM","requiredAsterisk":"Info_requiredAsterisk__3niId"};